import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dc5ec7b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4dc5ec7b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5ec7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc5ec7b')) {
      api.createRecord('4dc5ec7b', component.options)
    } else {
      api.reload('4dc5ec7b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dc5ec7b&scoped=true", function () {
      api.rerender('4dc5ec7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/registerManagement/index.vue"
export default component.exports